/* eslint-disable import/prefer-default-export */
/* eslint-disable max-len */
import { toastr } from 'react-redux-toastr';
import { SET_SYSTEM_SPECIFIC_FEATURES } from './publicConfigs.actions';
import * as api from '../../services/api/publicConfigs.service';

/** @type {ApiPublicConfigs.IPublicConfigsPresentationModel} */
const emptyPublicConfigs = {
    appEnvironment: '',
    isMultiLanguage: true,
    hrisUrl: '',
    version: '',
    isWorkplanIntegrationEnabled: false,
    employeeRedirectUrl: '',
    managerRedirectUrl: '',
    adminRedirectUrl: '',
};

export const fetchPublicConfigs = (isSetSessionStorage = false) => /** @param {import('redux').Dispatch} dispatch */async (dispatch) => {
    try {
        const { data: publicConfigs } = await api.getPublicConfigs();
        if (isSetSessionStorage) {
            Object.keys(emptyPublicConfigs).forEach((key) => {
                sessionStorage.setItem(key, publicConfigs[key]);
            });
        }

        dispatch({
            type: SET_SYSTEM_SPECIFIC_FEATURES,
            payload: {
                ...publicConfigs.featureSettings,
            },
        });
    } catch (error) {
        toastr.error('Fetching public configs', 'Failed to fetch');
    }
};